import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService, loginSuccess, MessageService } from '@pos-app/core-ui';
import { CatalogueStatus, KEYS, UserProfile, USER_ROLE } from '@pos-app/data';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { finalize, first } from 'rxjs/operators';

@Component({
    selector: 'app-login-to',
    templateUrl: './login-to.component.html',
    styleUrls: ['./login-to.component.scss'],
    standalone: false
})
export class LoginToComponent implements OnInit {
  @Input() userProfile: UserProfile;
  @Input() skipLoginToOption: Observable<boolean>;
  @ViewChild('content', { static: true }) modalBox: any;
  @Output() loggedIn = new EventEmitter<void>();
  private _loading$ = new BehaviorSubject<boolean>(false);
  loading$ = this._loading$.asObservable();
  USER_ROLE = USER_ROLE;
  allowProgrammeLoginOnly: boolean = false;

  constructor(private apiService: ApiService, private modalService: NgbModal, private messageService: MessageService) {}

  ngOnInit() {
    // //  when showCodes or ProgrammeCodes array not empty usual process
    // if (this.userProfile.ShowCodes.length >= 1 || this.userProfile.ProgrammeCodes.length >= 1) {
    //   this.usualProcess();
    // } else { // check if user is allowed to login to programme only then skip login to option
    this.apiService
      .fetchUserState()
      .pipe(first())
      .subscribe((res) => {
        if (res?.allowProgrammeLoginOnlyTF) {
          this.allowProgrammeLoginOnly = res?.allowProgrammeLoginOnlyTF;
          if (this.userProfile.ShowCodes.length >= 1 || this.userProfile.ProgrammeCodes.length >= 1) {
            this.usualProcess();
          } else {
            this.loggedIn.emit();
          }
        }
        this.userProfile = {
          ...this.userProfile,
          menuDisplayPreference: res.ARBCentralMenuBar,
        };
        localStorage.setItem(KEYS.jdeSession, JSON.stringify(this.userProfile));
        this.usualProcess();
      });
  }
  // }

  usualProcess() {
    if (this.userProfile.Role === USER_ROLE.guest && this.userProfile.ShowCodes.length === 1) {
      this.loginToShow(this.userProfile.ShowCodes[0].showCode);
    } else {
      // Internal and registered users to select the show or non-show
      this.modalService.open(this.modalBox, { backdrop: 'static' }).result.then(
        (_) => {},
        (_) => {
          // when escape => select non-show
          this.loggedIn.emit();
        }
      );
    }
  }

  loginTo(selectLocation: string) {
    if (selectLocation && this.userProfile.ShowCodes.find((item) => item.showCode === selectLocation)) {
      this.loginToShow(selectLocation);
    } else if (selectLocation && this.userProfile.ProgrammeCodes.find((item) => item.programmeCode === selectLocation)) {
      this.loginToProgram(selectLocation);
    } else {
      this._loading$.next(false);
      this.modalService.hasOpenModals() ? this.modalService.dismissAll() : this.loggedIn.emit();
    }
  }
  loginToShow(show: string) {
    this._loading$.next(true);
    //call the api to login to show and update the userProfile
    const showLogin = this.apiService.loginToShow({ showCode: show });
    showLogin.pipe(finalize(() => this._loading$.next(false))).subscribe((res) => {
      if (res) {
        let updatedProfile: UserProfile;
        updatedProfile = {
          ...this.userProfile,
          CustomerNumber: res.customerNumber,
          DefaultBranch: res.defaultBranch,
          DefaultBranchName: res.defaultBranchName,
          Role: res.userRole,
          ShowLocation: res.showLocation,
          ValidOrderTypes: res.validOrderTypesShow,
          ValidOrderTypesNonCorp: res.validOrderTypesNonCorp,
          ShowCodes: [this.userProfile.ShowCodes.find((item) => item.showCode === show)],
        };
        localStorage.setItem(KEYS.jdeSession, JSON.stringify(updatedProfile));
        this.messageService.dispatchAction(loginSuccess({ payload: updatedProfile }));
        // Update customer category when login to show
        let catalogueStatus: CatalogueStatus = {
          catalogueVisibleYN: res.catalogueVisibleYN,
          catalogueEnabledYN: res.catalogueEnabledYN,
          customerCategory: 'retail',
        };
        localStorage.setItem(KEYS.catalogueStatus, JSON.stringify(catalogueStatus));
      }
      this._loading$.next(false);
      this.modalService.hasOpenModals() ? this.modalService.dismissAll() : this.loggedIn.emit();
    });
  }
  loginToProgram(program: string) {
    this._loading$.next(true);
    //call the api to login to program and update the userProfile
    const showLogin = this.apiService.loginToProgramme({ programmeCode: program });
    showLogin.pipe(finalize(() => this._loading$.next(false))).subscribe((res) => {
      if (res) {
        const newSecurityFunction = res?.hideBuyPriceTF
          ? this.userProfile.SecurityFunctions.filter((item) => item !== 'SeeBuyPrice')
          : this.userProfile.SecurityFunctions;
        let updatedProfile: UserProfile;
        updatedProfile = {
          ...this.userProfile,
          CustomerNumber: res.customerNumber,
          DefaultBranch: res.defaultBranch,
          DefaultBranchName: res.defaultBranchName,
          Role: res.userRole,
          ShowLocation: res.showLocation,
          ValidOrderTypes: res.validOrderTypes,
          ProgrammeCodes: [this.userProfile.ProgrammeCodes.find((item) => item.programmeCode === program)],
          ProgrammeName: res.customerName,
          SecurityFunctions: newSecurityFunction,
        };
        localStorage.setItem(KEYS.jdeSession, JSON.stringify(updatedProfile));
        this.messageService.dispatchAction(loginSuccess({ payload: updatedProfile }));
        // Update customer category when login to show
        let catalogueStatus: CatalogueStatus = {
          catalogueVisibleYN: res.catalogueVisibleYN,
          catalogueEnabledYN: res.catalogueEnabledYN,
          customerCategory: 'retail',
        };
        localStorage.setItem(KEYS.catalogueStatus, JSON.stringify(catalogueStatus));
      }
      this._loading$.next(false);
      this.modalService.hasOpenModals() ? this.modalService.dismissAll() : this.loggedIn.emit();
    });
  }
}

